enum CustomPollMultipleChoiceQuestion {
    CustomChoiceId = -100
}

export default CustomPollMultipleChoiceQuestion;